module.exports = __webpack_public_path__ + "static/img/leet-pic.cdf0fb7d.jpg";